import ApiService from "./ApiService";

const ReferralService = {
    getActiveEvent: async () => {
        const result = await ApiService.getData("/home/referral/events/active");
        return result;
    },

    getEvent: async (eventId) => {
        const result = await ApiService.getData(`/home/referral/events/${eventId}`);
        return result;
    },

    sendInvitation: async (cloudUserId, eventId, inviteeEmail) => {
        const param = {
            inviteeEmail: inviteeEmail,
        };

        const result = await ApiService.postData(`/home/referral/${cloudUserId}/${eventId}/invites`, param);
        return result;
    },

    getInvitationDetails: async (token, eventId) => {
        const result = await ApiService.getData("/home/referral/accept", { token, eventId });
        return result;
    },

    getInvites: async (eventId, inviterId) => {
        const result = await ApiService.getData(`/home/referral/${eventId}/${inviterId}/invites`);
        return result;
    },
};

export default ReferralService;

